
export default {
  name: 'Affiliate',
  head: {
    title: 'Affiliate Program',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'This is the affiliate page of Motion Routes which includes the affiliate program.',
      },
      {
        hid: 'keywords',
        name: 'keywords',
        keywords:
          'motion routes, motion routes affiliate, after effects tutorial,after effects tutorial effects,after effects tutorials,after effects tutorials adobe,after effects tutorial adobe,after effects tutorial beginner,after effects tutorial animation,animation in after effects tutorial,after effects tutorial for beginners,after effects tutorial motion graphics,after effects tutorial transition,mask in after effects tutorial,text in after effects tutorial,after effects tutorial intro,after effects tutorial masking,after effects tutorial text animation,after effects tutorial youtube,after effects tutorial logo animation',
      },
    ],
  },
};
